/**
 * Upload size constants — single source of truth for file upload limits.
 *
 * Mirrored backend-side in `functions/src/lib/uploadLimits.ts`. When changing
 * values here, update the backend mirror and `storage.rules` in the same pass.
 *
 * Raised to 25MB/100MB on 2026-05-06 (was 10MB per file).
 * Raised to 50MB/250MB on 2026-06-06 to accommodate large scanned fax batches
 * (9+ PDFs at 15-30 MB each, 2026-06-05 Fernando test: 9 faxes failed Layer 1).
 */

/** Maximum raw bytes per uploaded file (50 MB). */
export const MAX_UPLOAD_BYTES_PER_FILE = 50 * 1024 * 1024;

/** Maximum aggregate raw bytes across all attachments in a single request (250 MB). */
export const MAX_UPLOAD_BYTES_TOTAL = 250 * 1024 * 1024;

/** Human-readable label used in UI messages (no trailing period). */
export const MAX_UPLOAD_LABEL_PER_FILE = '50MB';
export const MAX_UPLOAD_LABEL_TOTAL = '250MB';
